<template>
    <div class="ranking-page">
        <!-- 背景图 -->
        <div class="ranking-page-bg"></div>
        <!-- top -->
        <div class="top" :style="{paddingTop: 10 + statusBarHeight + 'px'}">
            <div
                class="top-back"
            >
                <Back 
                    :clickHandle="handleClosePage"
                    :innerText="localesPackage?.['badgewall_back']?.[localesEnv]"
                />
            </div>
        </div>
        <!-- switch -->
        <div class="switch">
            <div class="switch-item switch-item-left"
                @click="switchHandle('point')"
                :class="[{'active-left': currentShow == 'point'}]">
                <div class="switch-normalText"
                    :class="[{'active-text': currentShow == 'point'}]"
                >
                  {{ localesPackage?.['badgewall_point']?.[localesEnv] }}
                </div>
            </div>
            <div class="switch-item"
                @click="switchHandle('medal')"
                :class="[{'active': currentShow == 'medal'}]">
                <div class="switch-normalText"
                    :class="[{'active-text': currentShow == 'medal'}]"
                >
                {{ localesPackage?.['badgewall_medal']?.[localesEnv] }}
                </div>
            </div>
        </div>
        <!-- ranking tips -->
        <div class="ranking-tips" v-show="showDataGroup.length > 0">
            {{ localesPackage?.['badgewall_ranking_tips']?.[localesEnv] }}
        </div>
        <!-- ranking view -->
        <div class="ranking-view" ref="listView_ref" v-if="showDataGroup.length > 0">
            <div class="ranking-view-item" 
                :class="{
                    'no1': item.ranking == 1,
                    'no2': item.ranking == 2,
                    'no3': item.ranking == 3,
                }"
                 v-for="(item, index) in showDataGroup" 
                 :key="index">
                <div class="ranking-view-item-left">
                    <!-- 前三名特殊 -->
                    <img v-if="item?.ranking <= 3" 
                         :src="require(`@/assets/images/YuliApp/badgeWall/honerPage/ranking/no${item.ranking}.png`)"
                         class="ranking-view-item-left-rankingIcon">
                    <div v-else class="ranking-view-item-left-rankingNum">{{ item.ranking }}</div>
                    <img :src="item.avatar_url" class="ranking-view-item-left-userIcon" :onerror="imageLoadFailed">
                    <div class="ranking-view-item-left-userName">{{ item.username }}</div>
                </div>
                <div class="ranking-view-item-right">
                    <span class="ranking-view-item-right-num">{{ item.arg }}</span>
                    <span class="ranking-view-item-right-text">
                        {{ 
                            currentShow == "point" 
                            ? localesPackage?.['badgewall_points']?.[localesEnv]
                            : localesPackage?.['badgewall_medals']?.[localesEnv]
                        }}
                    </span>
                </div>
            </div>
        </div>
        <div class="ranking-nodata" v-else>
            <img :src="require('@/assets/images/YuliApp/badgeWall/honerPage/ranking/nodata_ranking.png')">
            <div class="ranking-nodata-text">
                {{ localesPackage?.['badgewall_no_rankingdata']?.[localesEnv] }}
            </div>
        </div>
        <!-- self -->
        <div class="ranking-view-item ranking-view-self" @click="selfClickHandle" v-if="self && showDataGroup.length > 9">
            <div class="ranking-view-item-left">
                <!-- 前三名特殊 -->
                <div class="ranking-view-item-left-rankingNum">{{ self.ranking }}</div>
                <img :src="self.avatar_url" class="ranking-view-item-left-userIcon" :onerror="imageLoadFailed">
                <div class="ranking-view-item-left-userName">{{ self.username }}</div>
            </div>
            <div class="ranking-view-item-right">
                <span class="ranking-view-item-right-num">{{ self.arg }}</span>
                <span class="ranking-view-item-right-text">
                    {{ 
                        currentShow == "point" 
                        ? localesPackage?.['badgewall_points']?.[localesEnv]
                        : localesPackage?.['badgewall_medals']?.[localesEnv]
                    }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { onBeforeMount, onMounted, ref, computed, nextTick } from "vue";
import _ from "lodash";
import { mapState } from "vuex";
import appBridging from "@/utils/appBridging.js";
import { getTime } from "@/utils/utils";
import { px2rem } from "@//utils/utils.js";
import Back from "@/components/universal/Back";

export default {
    components: {
        Back
    },
    props: {
        rankData: {
            type: Object,
            default: () => {
                return null
            }
        }
    },
    computed: {
        ...mapState({
            init: (state) => state.global.init,
            statusBarHeight: (state) => state.global.statusBarHeight,
            languageEnv: (state) => state.global.languageEnv,
            languagePackage: (state) => state.global.languagePackage,
        }),
    },
    watch: {
        rankData: {
            async handler(value) {
                console.log(value);
                if(value){
                    // console.log('rankData: ', value);
                    this.totalData = value;
                }
            },
            immediate: true,
            deep: true,
        },
        languageEnv: {
            async handler(value) {
                if(value){
                this.localesEnv = value;
                }
            },
            immediate: true,
            deep: true,
        },
        languagePackage: {
            async handler(value) {
                if(value){
                this.localesPackage = value;
                }
            },
            immediate: true,
            deep: true,
        }
    },
    setup(props, { emit }) {
        /**语言包 - ref */
        const localesPackage = ref({});
        /**语言环境 - ref */
        const localesEnv = ref('en');
        const currentShow = ref('point');
        const totalData = ref(null);
        const listView_ref = ref(null);
        const showDataGroup = ref([]);
        const self = ref(null);
        const selfClickTimes = ref(3); 
        onBeforeMount(()=>{
            appBridging.getStatusBarHeight();
            switchHandle('point', 'ignore');
        })

        /**头像加载失败事件 */
        const imageLoadFailed = (imgErrorEvent) => {
            const img = imgErrorEvent?.srcElement;
            if(img){
                img.src = require('@/assets/images/YuliApp/badgeWall/honerPage/ranking/default_avatar.png');
            }
        }

        const handleClosePage = () => {
            emit('handle','rank-close');
        }

        const switchHandle = (val, state) => {
            if(currentShow.value == val && state !== 'ignore')return;
            currentShow.value = val;
            let data = _.cloneDeep(totalData.value?.[val]) || [];
            if(data.length > 0){
                const userAddress = totalData.value?.userAddress;
                self.value = data.filter(item => item.address == userAddress)?.[0] || null;
                // const selfLocal = _.cloneDeep(self.value);
                // selfLocal.avatar_url = props.rankData?.appUserInfo?.avatar_url || selfLocal.avatar_url;
                // selfLocal.username = props.rankData?.appUserInfo?.username || selfLocal.username;
                // self.value = selfLocal;
                // data.pop(); // 最后一个数据,固定为自己,不展示（后端规则）
                // 去除所有分数为0的数据
                data = data.filter(item => item.arg > 0);
            }
            
            showDataGroup.value = data;
            nextTick(()=>{
                listView_ref.value.scrollTop = 0;
            })
        }

        /** 捕获用户自我点击事件*/
        const selfClickHandle = () => {
            selfClickTimes.value = 3;
            selfClick();
        }

        /** 自我点击执行器*/
        const selfClick = () => {
            console.log('selfClick: ', selfClickTimes.value);
            const item = listView_ref.value?.querySelector('.ranking-view-item');
            let offsetNum;
            if(self.value.ranking < 10){
                offsetNum = 0;
            }else {
                offsetNum = (item.offsetHeight + 6) * (self.value.ranking - 1);
            }
            listView_ref.value.scrollTop = offsetNum;
            // 多次修改定点, 强制渲染画面 ios 滚动过渡bug
            nextTick(()=>{
                setTimeout(() => {
                    if(selfClickTimes.value > 0){
                        selfClick();
                        selfClickTimes.value --;
                    }
                }, 55);
            })
        }

        return {
            switchHandle,
            handleClosePage,
            selfClickHandle,
            currentShow,
            localesPackage,
            localesEnv,
            listView_ref,
            self,
            totalData,
            showDataGroup,
            imageLoadFailed
        };
    },
};
</script>
  
<style lang="less" scoped>
@topHeight: 60px;
@screenTop: 10px;
.ranking-page{
    width: 100vw;
    height: 100vh;
    position: fixed;
    background: linear-gradient(180deg,
        #463D55 0%,
        #473F54 25%,
        #584A5C 50%,
        #745E6A 75%,
        #E1C893 100%
    );
    z-index: 999;
    top: 0;
    left: 0;
    &-bg{
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: -1;
        background: url("~@/assets/images/YuliApp/badgeWall/honerPage/MedelWallBg.png") no-repeat
        top left;
        background-size: 100% 100%;
    }
    .top{
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1;
        width: 100%;
        height: @topHeight;
        &-back{
            position: absolute;
            width: 64px;
            height: 32px;
            top: 50%;
            left: 0;
            transform: translate(0,-50%);
            img{
                width: 100%;
                height: 100%;
            }
        }
        &-right{
            position: absolute;
            top: 50%;
            right: 0;
            transform: translateY(-50%);
            &-iconView{
                width: 82px;
                height: 26px;
                position: relative;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                color: #ffffff;
                font-family: "PingFang SC";
                font-size: 12px;
                font-weight: 500;
                &-bg{
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    z-index: -1;
                }
                &-icon-share{
                    width: 24px;
                    height: 24px;
                    margin-right: 2px;
                }
            }
        }
        &-tag{
            position: absolute;
            top: 50%;
            right: 0;
            transform: translate(0,-50%);
            font-size: 16px;
            width: fit-content;
            height: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 4px 10px;
            background-color: aquamarine;
            border-radius: 20px 0 0 20px;
        }
    }
    .switch{
        margin-top: calc(@topHeight + @screenTop + 10px);
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 100%;

        &-item{
            line-height: 34px;
            // width: 50%;
            // height: 100%;
            width: 155px;
            height: 31px;
            background: url("~@/assets/images/YuliApp/badgeWall/honerPage/ranking/normal_switch.png") no-repeat top left;
            background-size: 100% 100%;
            // margin: 0 10px;
            position: relative;
        }
        &-item-left{
            background: url("~@/assets/images/YuliApp/badgeWall/honerPage/ranking/normal_switch_left.png") no-repeat top left;
            background-size: 100% 100%;
        }
        &-normalText{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            z-index: 1;
            color: #ecedee;
            font-size: 18px;
            font-weight: 500;
            font-family: "PingFang SC";
            text-align: center;
        }
        .active{
            background: url("~@/assets/images/YuliApp/badgeWall/honerPage/ranking/active_switch.png") no-repeat top left;
            background-size: 100% 100%;
        }
        .active-left{
            background: url("~@/assets/images/YuliApp/badgeWall/honerPage/ranking/active_switch_left.png") no-repeat top left;
            background-size: 100% 100%;
        }
        .active-text{
            color: #000;
        }
    }
    .ranking-tips{
        margin: 20px 0 8px 15px;
        color: #ffffff;
        text-align: left;
        font-family: "PingFang HK";
        font-size: 14px;
        font-weight: 600;
        line-height: 15px;
    }
    .ranking-view{
        display: flex;
        flex-direction: column;
        width: 345px;
        height: calc(100vh * 514/812);
        overflow-x: hidden;
        overflow-y: scroll;
        margin: 0 auto;
        position: relative;
        &-item{
            width: 100%;
            height: 46px;
            margin-bottom: 6px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            background: rgba(255, 255, 255, 0.5);
            border: 1px solid rgba(0, 0, 0, 0.18);
            &-left{
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                text-align: center;
                font-family: "PingFang SC";
                &-rankingIcon{
                    width: 32px;
                    height: 32px;
                    margin: 0 4px 0 8px;
                }
                &-rankingNum{
                    width: 37px;
                    text-align: center;
                    color: rgba(46, 46, 46, 0.8);
                    font-size: 18px;
                    font-weight: 600;
                    margin: 0 3px 0 4px;
                }
                &-userIcon{
                    width: 32px;
                    height: 32px;
                    border-radius: 32px;
                    border: 1px solid rgba(255, 255, 255, 0.7);
                    margin-right: 6px;
                }
                &-userName{
                    color: rgb(62, 57, 55);
                    font-size: 14px;
                    font-weight: 600;
                    text-align: left;
                    width: 160px;
                    height: 100%;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
            &-right{
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                color: rgba(46, 46, 46, 0.8);
                font-family: "PingFang SC";
                font-size: 14px;
                font-weight: 600;
                &-num{
                    margin-right: 4px;
                }
                &-text{
                    margin-right: 14px;
                    white-space: nowrap;
                }
            }
        }
        .no1{
            background: url("~@/assets/images/YuliApp/badgeWall/honerPage/ranking/no1_bg.png") no-repeat
            top left;
            background-size: 100% 100%;
            border: unset;
            .ranking-view-item-right{
                color: rgba(168, 71, 0, 1);
            }
        }
        .no2{
            background: url("~@/assets/images/YuliApp/badgeWall/honerPage/ranking/no2_bg.png") no-repeat
            top left;
            background-size: 100% 100%;
            border: unset;
            .ranking-view-item-right{
                color: rgba(50, 105, 156, 1);
            }
        }
        .no3{
            background: url("~@/assets/images/YuliApp/badgeWall/honerPage/ranking/no3_bg.png") no-repeat
            top left;
            background-size: 100% 100%;
            border: unset;
            .ranking-view-item-right{
                color: rgba(139, 87, 65, 1);
            }
        }
        &-self{
            // position: fixed;
            // bottom: 0;
            // left: 0;
            background: rgba(255, 255, 255, 1);
            margin: 0 auto;
            width: 345px;
            .ranking-view-item-right{
                color: rgba(168, 71, 0, 1);
            }
        }
    }
    .ranking-nodata{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 70%;
        width: 100%;
        img{
            width: 120px;
            height: 120px;
            margin-bottom: 32px;
        }
        &-text{
            color: #76736f;
            font-size: 15px;
            font-weight: 600;
            font-family: "PingFang HK";
        }
    }
}
</style>